const ActivityState = {
    ACTIVE: 1,
    IN_MEETING: 2,
    INACTIVE: 3,
    LOGGED_OUT: 4
};

module.exports = {
    ActivityState
}
